import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const ArrowRightIcon: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.58981 8.99998L0.468357 2.11175C0.110804 1.76591 0.110809 1.20519 0.468366 0.859353C0.825923 0.513514 1.40563 0.513517 1.76319 0.85936L9.53203 8.37378C9.88958 8.71962 9.88958 9.28033 9.53203 9.62617L1.76319 17.1406C1.40563 17.4864 0.825923 17.4864 0.468366 17.1406C0.110809 16.7948 0.110804 16.234 0.468357 15.8882L7.58981 8.99998Z"
      fill={fill}
    />
  </svg>
);

export default ArrowRightIcon;
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const ArrowRightIcon: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.58981 8.99998L0.468357 2.11175C0.110804 1.76591 0.110809 1.20519 0.468366 0.859353C0.825923 0.513514 1.40563 0.513517 1.76319 0.85936L9.53203 8.37378C9.88958 8.71962 9.88958 9.28033 9.53203 9.62617L1.76319 17.1406C1.40563 17.4864 0.825923 17.4864 0.468366 17.1406C0.110809 16.7948 0.110804 16.234 0.468357 15.8882L7.58981 8.99998Z"
      fill={fill}
    />
  </svg>
);

export default ArrowRightIcon;
